import * as Api from '@ViewModels';
import { useEffect, useState } from 'react';
import { useBaseStepState } from './useBaseStepState';

interface UseTagStepStateProps {
	tagStep: Api.IAddTagAutomationStep | Api.IRemoveTagAutomationStep | null;
	template: Api.IAutomationTemplate | null;
	stepId: string;
	readonly: boolean;
	onSaveSuccess?: () => void;
	onSaveError?: (error: Api.IOperationResultNoValue) => void;
}

interface UseTagStepStateResult {
	tagName: string;
	setTagName: (name: string) => void;
	showRequiredFieldError: boolean;
	setShowRequiredFieldError: (show: boolean) => void;
	autoSave: ReturnType<typeof useBaseStepState>['autoSave'];
	clearInlineErrorMessage: () => void;
}

/**
 * State management hook for TagStepRenderer.
 * Handles tag name state, validation errors, and auto-save setup.
 */
export function useTagStepState({
	tagStep,
	template,
	stepId,
	readonly,
	onSaveSuccess,
	onSaveError,
}: UseTagStepStateProps): UseTagStepStateResult {
	const [tagName, setTagName] = useState(tagStep?.tagName || '');

	const baseState = useBaseStepState({
		step: tagStep,
		template,
		stepId,
		readonly,
		onSaveSuccess,
		onSaveError,
	});

	useEffect(() => {
		setTagName(tagStep?.tagName || '');
	}, [tagStep?.tagName]);

	return {
		tagName,
		setTagName,
		showRequiredFieldError: baseState.showRequiredFieldError,
		setShowRequiredFieldError: baseState.setShowRequiredFieldError,
		autoSave: baseState.autoSave,
		clearInlineErrorMessage: baseState.clearInlineErrorMessage,
	};
}
